import React from 'react';

const InputForm = ({ formData, setFormData, onCalculate }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <form onSubmit={onCalculate} className="space-y-6">
      <div className="flex justify-center mb-6">
        <div className="bg-gray-100 dark:bg-gray-700/50 p-1 rounded-xl flex text-sm font-semibold">
          {['metric', 'imperial'].map(u => (
            <button
              key={u}
              type="button"
              onClick={() => setFormData(p => ({ ...p, unit: u }))}
              className={`px-6 py-2 rounded-lg transition-all capitalize ${formData.unit === u ? 'bg-white dark:bg-gray-600 shadow-sm text-blue-600 dark:text-white' : 'text-gray-500'}`}
            >
              {u}
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <label className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-2 block">Gender</label>
          <div className="grid grid-cols-2 gap-2">
            {['male', 'female'].map(g => (
              <button
                key={g}
                type="button"
                onClick={() => setFormData(p => ({ ...p, gender: g }))}
                className={`py-3 rounded-xl border-2 capitalize font-bold transition-all ${formData.gender === g ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20 text-blue-700 dark:text-blue-300' : 'border-transparent bg-gray-100 dark:bg-gray-800 text-gray-500'}`}
              >
                {g}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-2 block">Age</label>
          <input type="number" name="age" value={formData.age} onChange={handleChange} className="w-full bg-gray-100 dark:bg-gray-800 border-none rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none font-bold" required />
        </div>

        <div>
          <label className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-2 block">Height ({formData.unit === 'metric' ? 'cm' : 'in'})</label>
          <input type="number" name="height" value={formData.height} onChange={handleChange} className="w-full bg-gray-100 dark:bg-gray-800 border-none rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none font-bold" required />
        </div>

        <div>
          <label className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-2 block">Weight ({formData.unit === 'metric' ? 'kg' : 'lbs'})</label>
          <input type="number" name="weight" value={formData.weight} onChange={handleChange} className="w-full bg-gray-100 dark:bg-gray-800 border-none rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none font-bold" required />
        </div>

        <div className="md:col-span-2">
          <label className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-2 block">Activity Level</label>
          <select name="activity" value={formData.activity} onChange={handleChange} className="w-full bg-gray-100 dark:bg-gray-800 border-none rounded-xl px-4 py-3 focus:ring-2 focus:ring-blue-500 outline-none font-bold appearance-none">
            <option value="sedentary">Sedentary (No Exercise)</option>
            <option value="light">Light (1-2 days/week)</option>
            <option value="moderate">Moderate (3-5 days/week)</option>
            <option value="very_active">Very Active (6-7 days/week)</option>
            <option value="athlete">Professional / Athlete</option>
          </select>
        </div>
      </div>

      <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-extrabold py-4 rounded-2xl shadow-xl shadow-blue-500/20 transition-all transform active:scale-[0.98] uppercase tracking-widest text-sm">
        Generate Metabolic Blueprint
      </button>
    </form>
  );
};

export default InputForm;